module.exports = __webpack_public_path__ + "static/sec2-d8bc63bde4efb4cf41b7ca8cfb40dcce.png";